import { useCallback } from 'react';
import { useTicketFlowModals } from '../../context';

type UseCallCustomerParams = {
  sectorId?: string;
  trackNumber?: string;
  onBeforeCall?: () => Promise<boolean | void>;
  onCall: (input: { sectorId: string; trackNumber: string }) => Promise<any>;
};

export function useCallCustomer({
  sectorId,
  trackNumber,
  onBeforeCall,
  onCall,
}: UseCallCustomerParams) {
  const { ticketData, setTicketData, openCallModal } = useTicketFlowModals();

  const onCallCustomer = useCallback(async () => {
    if (onBeforeCall) {
      const shouldContinue = await onBeforeCall();
      if (shouldContinue === false) return;
    }

    const finalSectorId = sectorId || ticketData?.sectorId;
    const finalTrackNumber = trackNumber || ticketData?.trackNumber;

    if (!finalSectorId || !finalTrackNumber) return;

    const data = await onCall({
      sectorId: finalSectorId,
      trackNumber: finalTrackNumber,
    });

    if (data) {
      setTicketData({
        ...data,
        isAlreadyTaken: !!onBeforeCall,
      });
      openCallModal();
    }
  }, [
    onBeforeCall,
    onCall,
    openCallModal,
    sectorId,
    setTicketData,
    ticketData?.sectorId,
    ticketData?.trackNumber,
    trackNumber,
  ]);

  return { onCallCustomer };
}

